module.exports = __webpack_public_path__ + "static/media/my-courses.109d0d12.gif";